import { BCDataGrid } from '@bimser/components';
import { compareMatchWithCollection } from '@bimser/core';
import get from 'lodash/get';
import DataGrid2 from '../..';

export function createArrayStore(this: DataGrid2) {
	let rows = this.rows;

	if (this.hiddenRowColumnName && this.hiddenRowValueMatchers.values.length) {
		rows = rows.filter(
			row =>
				!this.hiddenRowValueMatchers.values.some(compareValue =>
					compareMatchWithCollection({
						value: get(row.data, this.hiddenRowColumnName),
						editType: this.hiddenRowValueMatchers.editType,
						dataType: this.__getBCColumn(this.hiddenRowColumnName).dbType.type,
						compareValue
					})
				)
		);
	}

	return new BCDataGrid.Components.DataSource({
		langParams: { locale: this.__form.currentLanguage.twoLetterCulture },
		store: new BCDataGrid.Components.ArrayStore({
			key: this.getUniqueDataField(),
			data: rows.map(({ data }) => data),
			onInserted: async data => {
				await this.__notifyDataGridRows([...this.rows, this.newRow({ data })]);
			},
			onUpdated: async (key, data) => {
				const keyExpr = this.getUniqueDataField();

				await this.__notifyDataGridRows(
					this.rows.map(row => {
						if (row.data[keyExpr] === key) {
							return this.newRow({
								data: { ...row.data, ...data },
								index: row.index
							});
						}

						return row;
					})
				);
			},
			onRemoved: async key => {
				const keyExpr = this.getUniqueDataField();

				await this.__notifyDataGridRows(this.rows.filter(row => key !== row.data[keyExpr]));
			}
		})
	});
}
